import React from "react";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";
import AuthHeader from "../Authentication/AuthHeader";
import AuthFooter from "../Authentication/AuthFooter";
import { UnsavedChangesProvider } from "./UnsavedChanges";
import "../Authentication/AuthLayout.css";

var FORM_PATHS = ["/new-joinee", "/sdf", "/epf", "/form11", "/formf", "/formq", "/nda"];

export function isJoineeFormPath(pathname) {
  return FORM_PATHS.indexOf(String(pathname || "").toLowerCase()) !== -1;
}

/**
 * Shared New Joinee shell: Auth header/footer + background.
 * Centers page content both horizontally and vertically (Figma).
 * Form pages drop the footer so the form card can use the full height.
 */
function JoineeLayout(props) {
  var location = useLocation();
  var content = props.children !== undefined ? props.children : <Outlet />;
  var isFormPage = isJoineeFormPath(location.pathname);

  return (
    <UnsavedChangesProvider>
      <Box
        className="auth-page"
        sx={{
          position: "relative",
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowX: "hidden",
          "--joinee-shell-offset": isFormPage ? "120px" : "168px",
        }}
      >
        <AuthHeader showLogout />

        <Box
          component="main"
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 1.5, sm: 3, md: 4 },
            py: { xs: 2, sm: 2.5, md: 3 },
            width: "100%",
            boxSizing: "border-box",
            position: "relative",
            zIndex: 1,
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 1240,
            }}
          >
            {content}
          </Box>
        </Box>

        {isFormPage ? null : <AuthFooter />}
      </Box>
    </UnsavedChangesProvider>
  );
}

export default JoineeLayout;
